export default function screenWidthIsGdocsExtension(): boolean {
  return (window.innerWidth || document.documentElement.clientWidth) <= 590;
}
